<template>
  <div>
    <el-dialog :close-on-click-modal="false"  
      title="订单详情"
      :visible.sync="visible"
      top="6vh"
      width="1100px"
      class="editDialog"
      :before-close="handleClose"
    >
      <div class="order-info-box">
        <div class="fl">
          <b>订单号： </b>
          {{ orderData.order.appNo }}
        </div>
        <div class="fl">
          <b>平台渠道： </b>
          {{ dictMap["plat_no"][orderData.order.platNo] }}
        </div>
        <div class="fl" style="width: 35%;">
          <b>店铺账号： </b>
          {{ orderData.order.shopName }}
        </div>
        <div class="fl" style="width: 15%;">
          <b>订单状态： </b>
          {{ orderData.order.amazonOrderStatus }}
        </div>
      </div>
      <div style="max-height: 54vh;overflow: auto;">
        <div class="order-card" id="edit_order">
          <div class="title">
            订单信息
          </div>
          <div class="content">
            <div class="buyer-detail">
              <div class="flex1">
                买家账号： {{ orderData.addr.buyerEmail }}
              </div>
              <div class="flex1">买家姓名： {{ orderData.addr.buyerName }}</div>
              <div class="flex1">
                来源国家：<span v-if="orderData.order.amazonSite">
                  {{ dictMap["amazon_site"][orderData.addr.state] }}</span
                >
              </div>
            </div>
            <el-table
              :data="orderData.order.skuList"
              border
              style="width: 100%"
            >
              <el-table-column label="产品信息">
                <template slot-scope="scope">
                  <div class="table-info-wrap">
                    <div class="table-info">
                      <div class="left">
                        <img class="mini-img" :src="scope.row.picUrl" />
                      </div>
                      <div class="right">
                        <div
                          :title="scope.row.amazonProductName"
                          class="text-ellipsis"
                          style="width: 641px"
                        >
                          {{ scope.row.amazonProductName }}
                        </div>
                        <div :title="scope.row.itemSku" class="text-ellipsis">
                          {{ scope.row.itemSku }}
                        </div>
                        <div v-if="scope.row.proName">
                          {{ scope.row.proName }}({{ scope.row.designId }})
                        </div>
                        <div
                          :title="scope.row.properVal"
                          class="text-ellipsis"
                          v-if="scope.row.properName"
                        >
                          <span
                            v-if="scope.row.properName && scope.row.properVal"
                          >
                            <span
                              v-for="(i, ind) in [0, 1]"
                              :key="'i_' + ind"
                              style="margin-right: 10px;"
                            >
                              {{ scope.row.properName.split(":")[i] }}：
                              {{ scope.row.properVal.split(":")[i] }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="num" label="数量" width="100">
              </el-table-column>
              <el-table-column prop="address" label="价格" width="150">
                <template slot-scope="scope">
                  {{ dictMap["currency_mark"][orderData.currency] }}
                  {{ scope.row.salePrice || "-" }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="content flex">
            <div class="fl">
              <b>销售总计： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.saleActPay || "-"  }}
            </div>
            <div class="fl">
              <b>产品金额： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.saleTotal || "-"  }}
            </div>
            <div class="fl">
              <b>运费： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.saleFare  || "-" }}
            </div>
            <div class="fl" v-if="false">
              <b>货款总计： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.proActPay || "-"  }}
            </div>
            <div class="fl" v-if="false">
              <b>产品货款： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.proTotal || "-"  }}
            </div>
            <div class="fl" v-if="false">
              <b>运费： </b>
              {{ dictMap["currency_mark"][orderData.order.currency] }}
              {{ orderData.order.proFare || "-"  }}
            </div>
          </div>
        </div>
        <div class="order-card" id="edit_deliver">
          <div class="title">
            收货信息
          </div>
          <div class="content flex">
            <div class="fl w50">
              <b>收件人： </b>
              <span v-if="!deliverIsEdit">{{ orderData.addr.receName }}</span>
              <el-input
                v-else
                v-model="orderData.addr.receName"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>国家： </b>
              <span v-if="!deliverIsEdit">{{
                dictMap["amazon_site"][orderData.addr.state]
              }}</span>
              <el-select
                clearable
                v-else
                v-model="orderData.addr.state"
                class="input"
                size="small"
              >
                <el-option
                  v-for="(value, index) in dictData['amazon_site']"
                  :key="index"
                  :label="value.label"
                  :value="value.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="fl w50">
              <b>省/州： </b>
              <span v-if="!deliverIsEdit">{{ orderData.addr.province }}</span>
              <el-input
                v-else
                v-model="orderData.addr.province"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>城市： </b>
              <span v-if="!deliverIsEdit">{{ orderData.addr.city }}</span>
              <el-input
                v-else
                v-model="orderData.addr.city"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>地址： </b>
              <span v-if="!deliverIsEdit">{{ orderData.addr.detailAddr }}</span>
              <el-input
                v-else
                v-model="orderData.addr.detailAddr"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>电话： </b>
              <span v-if="!deliverIsEdit">{{
                orderData.addr.buyerPhoneNumber
              }}</span>
              <el-input
                v-else
                v-model="orderData.addr.buyerPhoneNumber"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50">
              <b>邮编： </b>
              <span v-if="!deliverIsEdit">{{ orderData.addr.zipCode }}</span>
              <el-input
                v-else
                v-model="orderData.addr.zipCode"
                class="input"
                size="small"
              />
            </div>
            <div class="fl w50"></div>
          </div>
        </div>
        <div class="order-card" id="edit_orderRecord">
          <div class="title">
            订单动态
          </div>
          <div class="content">
            <div
              class="step"
              v-if="orderData.process && orderData.process.length > 0"
            >
              <el-steps direction="vertical" :active="orderData.process.length">
                <el-step
                  :title="item && item.operLink"
                  v-for="(item, index) in orderData.process"
                  :key="index"
                >
                  <div v-if="item" slot="description">
                    <p>{{  item.operTime }}</p>
                    <p>{{ item.operNote }}</p>
                  </div>
                </el-step>
              </el-steps>
            </div>
            <div v-else>暂无</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sure" size="small">
          关闭
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "FbaOrderDetail",
  data() {
    return {
      updateModal: false,
      divideModal: false,
      currentOrder: {
        properName: "",
        properVal: "",
      },
      activeTab: "order",
      deliverIsEdit: false,
      activeStatus: 1,
      innerOrder: {},
      currentOrderSku: {
        attribute: "",
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    appId: {
      type: String,
      default() {
        return ""
      },
    },
    orderData: {
      type: Object,
      default() {
        return {
          order: {
            appNo: "",
          },
          expre: {
            shippingMethod: "",
            trackingNumber: "",
            createTime: "",
          },
          addr: {
            receName: "",
            country: "",
            province: "",
            city: "",
            detailAddr: "",
            buyerPhoneNumber: "",
            zipCode: "",
          },
        }
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap"]),
  },
  methods: {
    sure() {
      this.$emit("onClose")
    },
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped lang="scss">
.center {
  text-align: center;
}

.editDialog {
  font-size: 12px;

  .el-tabs__header {
    margin-bottom: -1px;
  }

  .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #f5f7fa;
    background: #f5f7fa;
  }
}

.order-info-box {
  background: #f5f7fa;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #ebeef5;
  flex-wrap: wrap;

  .fl {
    width: 25%;
  }
}

.order-card {
  margin-bottom: 10px;
  border: 1px solid #ebeef5;

  .title {
    background: #f5f7fa;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    font-weight: bold;
    border-bottom: 1px solid #ebeef5;
    position: relative;

    .right {
      position: absolute;
      right: 10px;
      color: #409eff;
      top: 12px;
      display: flex;
      align-items: center;

      span {
        display: inline-block;
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }

  .content {
    width: 100%;
    padding: 20px 10px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
      border: 0;
    }
  }
}

.order-card .content.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 10px;
  flex-wrap: wrap;

  .fl {
    width: 33.33%;
    margin: 2px auto;
    display: flex;
    align-items: center;
    height: 32px;

    b {
      width: 80px;
      text-align: right;
    }
  }
}

.w33 {
  width: 33.33% !important;
}

.w50 {
  width: 50% !important;
}

.table-info-wrap {
  margin-bottom: -10px;
}

.table-info {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 10px;
  padding: 0 10px;

  &:last-child {
    margin-bottom: 0;
    border-bottom: 0;
  }

  .left {
    margin-right: 20px;
    width: 100px;
    min-height: 100px;
    margin-bottom: 10px;

    .mini-img {
      width: 95px;
      height: 95px;
      border: 1px solid #ebeef5;
    }

    .id {
      width: 100%;
      text-align: center;
    }
  }
}

.operate {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.link {
  font-size: 12px;
  color: #1e7ec8;
  cursor: pointer;
}

.step {
  height: 300px;
  display: flex;
}

.step {
  .el-steps--vertical {
    width: 100%;
  }
}

.updateDialog {
  display: flex;

  .left {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border: 1px solid #ebeef5;
  }
}

.updateDialog .left img {
  width: 100%;
  height: 100%;
}

.updateDialog .right {
  display: flex;
  flex-direction: column;

  .title {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .list {
    display: flex;
    align-items: center;

    margin-bottom: 10px;

    .name {
      width: 80px;
    }

    .value {
      width: 100%;
    }
  }
}

.buyer-detail {
  display: flex;
  margin: 0 0 16px 0;
}

.flex1 {
  flex: 1;
}
</style>
